const heights = {
  topBar: 40,
};

export default heights;
